module.exports = __webpack_public_path__ + "img/pin-in-2.0867c9aa.svg";